import { objectDuckCreator } from '@atc/modular-redux';

const parsedQueryDuck = objectDuckCreator({
    store: 'parsedQuery',
});

export default parsedQueryDuck;
